import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { TippyV2 } from "@/react/components/shared/TippyV2";
import { Typography } from "@/react/components/shared/uikit/Typography";

const localeNamespace = "settings.workflows.templates.labels.ai_action";

export function AIActionLabel() {
  return (
    <div className="flex h-5 items-center gap-1 rounded pe-1 hover:bg-[#AB6DFB]/10">
      <TippyV2
        className="flex"
        interactive={false}
        key={t([localeNamespace, "description"])}
        content={t([localeNamespace, "description"])}
        placement="top"
        arrow={false}
        tooltipTextClassName="!max-w-[210px]"
      >
        <Icon type="10-stardust" size={10} className="text-[#AB6DFB]" />
        <Typography.LabelXxs color="text-[#AB6DFB]">
          {t([localeNamespace, "label"])}
        </Typography.LabelXxs>
      </TippyV2>
    </div>
  );
}
